// extracted by mini-css-extract-plugin
export default {"button":"Button_button__44bx0","yellow":"Button_yellow__hXqBE","purple":"Button_purple__oDKu4","grey":"Button_grey__iGGSc"};